import { createContext, useContext, useState, PropsWithChildren } from 'react';
import { Disclosure as Interface } from './types';

interface DisclosureProps extends PropsWithChildren {
  defaultValue?: boolean;
}

const Disclosure = ({ children, defaultValue = false }: DisclosureProps) => {
  const [value, updateValue] = useState(defaultValue);

  const toggle = () => updateValue((prev) => !prev);

  return (
    <Context.Provider value={{ value, toggle }}>{children}</Context.Provider>
  );
};

const Button = ({ children, ...props }: Interface.ButtonProps) => {
  const { value, toggle } = useDisclosure();

  return (
    <button type="button" onClick={toggle} aria-expanded={value} {...props}>
      {typeof children === 'function' ? children({ value }) : children}
    </button>
  );
};

const Panel = ({ children, ...props }: Interface.PanelProps) => {
  const { value } = useDisclosure();

  return (
    <div
      {...props}
      style={{ ...props.style, display: value ? undefined : 'none' }}
    >
      {children}
    </div>
  );
};

const Context = createContext<Interface.ContextType | undefined>(undefined);

export const useDisclosure = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useDisclosure must be used within a Disclosure component');
  }
  return context;
};

Disclosure.Button = Button;
Disclosure.Panel = Panel;

export default Disclosure;
